import apiHandler from "middlewares/apiHandler";
import { RegionModel } from "pages/Client/types";


export class MasterRegionsApi {

  apiHandler = apiHandler;
  baseURL = "/api/";

  _getRegions = async () => {
    return apiHandler.get<Array<RegionModel>>(`regions`);
  };

}
const masterRegionsApi = new MasterRegionsApi();
export default masterRegionsApi;